import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useSetState from '../../../hooks/useSetState';
import Table from '../../../components/table';
import { takeawayFinancialReport } from '../../../enums/columns/takeawayFinancialReport';

const TakeawayFinancialReportsList = ({ ...props }) => {
  const {  takeawayFactorList, getTakeawayFactorLoading, totalRecords } = useSelector(state => ({
    takeawayFactorList: state.takeawayReducer.takeawayFactorList,
    getTakeawayFactorLoading: state.takeawayReducer.getTakeawayFactorLoading,
    totalRecords: state.takeawayReducer.totalRecords,
  }));

  return (
    <section>
      <div className='bg-white p-2'>
        <div className="panel-heading">
          <i className="fas fa-list-alt px-1" />
          {locales('title.financial.report')}
        </div>
        <div className='table-responsive-lg'>
          <Table
            columns={takeawayFinancialReport}
            dataSource={takeawayFactorList}
            loading={getTakeawayFactorLoading}
            sort={{ type: props.sortType, action: props.sortTable }}
            pagination={{
              currentPage: props.pageNumber,
              pageSize: props.pageSize,
              totalCount: totalRecords || 0,
              onPageChange: props.onPageChanged,
            }}
          />
        </div>
      </div>
    </section>
  );
}

export default TakeawayFinancialReportsList;